module.exports = __webpack_public_path__ + "img/esquemaD.4088e99c.png";